import type { Slide } from '@features/powerpoint';
import { themeV2 } from '../../domain/theme-v2';
import { DEFAULT_FONT } from '../../utils/constants-v2';
import { SECTION_HEADER } from './section-title-slide-master-v2';

export const sectionTitleSlideV2 = (titleText: string): Slide => ({
  slideMaster: SECTION_HEADER,
  texts: [
    {
      text: titleText,
      options: {
        fontSize: themeV2.fontSizes.h1,
        fontFace: DEFAULT_FONT,
        color: themeV2.colors.white,
        bold: true,
        breakLine: true,
        h: 0.75,
        w: 8.88,
        x: 3.44,
        y: 3.1,
        lineSpacing: 90,
      },
    },
  ],
});
